module.exports = __webpack_public_path__ + "media/dashboard/assets/images/opportunity-pipelines/finish-success-13cf212496f82c343f32f3b3f38a0768.svg";